import {
  BOOSTER_SHIELD_BLINK_START_SEC,
  type BoosterKind,
} from '../catalog/boosters';
import type { RunnerPlayer } from './runnerTypes';

export function hasRunnerShieldBooster(player: RunnerPlayer): boolean {
  return player.activeBooster?.kind === 'shield';
}

export function getRunnerShieldBoosterRemainingSeconds(
  player: RunnerPlayer,
): number | null {
  if (player.activeBooster?.kind !== 'shield') {
    return null;
  }
  return player.activeBooster.remainingSeconds;
}

export function isRunnerShieldBoosterExpiringSoon(player: RunnerPlayer): boolean {
  const remaining = getRunnerShieldBoosterRemainingSeconds(player);
  return remaining != null && remaining <= BOOSTER_SHIELD_BLINK_START_SEC;
}

export function hasRunnerSpeedBooster(player: RunnerPlayer): boolean {
  return player.activeBooster?.kind === 'speed';
}

export function hasRunnerHitInvulnerability(player: RunnerPlayer): boolean {
  return player.hitInvulnerableRemainingSeconds > 0;
}

export function runnerSpriteVariant(player: RunnerPlayer): BoosterKind | 'normal' {
  const kind = player.activeBooster?.kind;
  if (kind === 'shield' || kind === 'speed') {
    return kind;
  }
  return 'normal';
}

export type RunnerLevelSession = {
  level: import('./runnerTypes').RunnerLevel;
  player: RunnerPlayer;
};
